module.exports = __webpack_public_path__ + "img/imgCheck.4cf0e118.svg";